import { useMutation, useQuery, useQueryClient, type UseQueryResult } from "@tanstack/react-query";

import { apiRequest } from "../../common/api/apiClient.js";
import { writeSelectedTenant } from "../../common/api/tenantStorage.js";
import type { MeDTO } from "../../common/api/types.js";

export const meQueryKey = ["me"] as const;

/** Wer ist angemeldet, in welchem Mandanten, mit welchen Rechten. */
export function useMe(enabled: boolean): UseQueryResult<MeDTO, Error> {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: () => apiRequest<MeDTO>("/me"),
    enabled,
  });
}

/** Wechselt den Mandanten und lädt danach alles neu, was mandantenabhängig ist. */
export function useSelectTenant(): ReturnType<typeof useMutation<void, Error, string>> {
  const client = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (slug: string) => {
      await client.cancelQueries();
      writeSelectedTenant(slug);
      await client.resetQueries();
    },
  });
}
